import { ManageEmailStylingPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/email-style'].update({
        staticData: { title: { page: 'Email.Style.PageHeading' } },
        component: authGuard(ManageEmailStylingPage, { canManageEmailStyle: true })
    });
};
